module.exports = __webpack_public_path__ + "img/features-phonetic.ba48c6c2.svg";